import React from "react";
import { useNavigate } from "react-router-dom";

import LoadingIndicator from "./common/components/LoadingIndicator";
import { logoutUser } from "../api/Auth";
import { useAuth } from "../context/AuthContext";
import { routes } from "../Router";
import { Container } from "react-bootstrap";

export default function Logout(): React.JSX.Element {
  const navigate = useNavigate();

  const { logout } = useAuth();

  React.useEffect(() => {
    logoutUser()
      .then(() => logout())
      .catch((error: IApiError) =>
        navigate(routes.error(error.statusCode || 401), { replace: true }),
      );
  }, [logout, navigate]);

  return (
    <Container fluid={true} className="w-100 min-h-100vh d-flex flex-column">
      <LoadingIndicator />
    </Container>
  );
}
